import React, { useEffect, useState } from "react";
import { Flex } from "../../pages/styled";
import {
  RecommendationWrapper,
  ResultContainer,
  ResultPhrase,
  ResultSubtitle,
  ResultTitle,
  StyledBackButton,
  StyledImage,
  StyledNextButton,
  YellowSection,
  YellowSectionSubtitle,
  YellowSectionTitle,
} from "./styled";

import Image1 from "../../assets/img/png/imagen1.png";
import Image2 from "../../assets/img/png/imagen2.png";
import Image3 from "../../assets/img/png/imagen3.png";

const imageUrls = [Image1, Image2, Image3];

export default function Recommendation({
  recommendation,
  name,
  startOver,
  url,
  contact,
}) {
  const [imageUrl, _] = useState(imageUrls[Math.floor(Math.random() * 3)]);

  useEffect(() => {
    const message = `Una persona ha tomado el tester de seguro ideal, estos son sus datos: \n Nombre: ${contact.name} \n Correo electronico: ${contact.email} \n Telefono: ${contact.phone} \n Interesado en: ${recommendation.title}`;
    fetch("https://confiansa.bi.com.gt/wp-json/services/v1/sendmail", {
      method: "POST",
      body: JSON.stringify({
        to: contact.email,
        subject1: "Alguien ha tomado el tester de seguro ideal",
        subject2: "Tu seguro ideal",
        message,
        recommendation: recommendation.title,
      }),
    });
  }, []);

  return (
    <RecommendationWrapper>
      <YellowSection>
        <Flex
          style={{ paddingLeft: "5%", width: "100%", paddingBottom: "1rem" }}
          className="reccommendationYellowContainer"
        >
          <Flex column centerV flex="1">
            <YellowSectionTitle>{`¡Excelente, ${name}!`}</YellowSectionTitle>
            <YellowSectionSubtitle>
              Examinamos tu información y el seguro perfecto para ti es:
            </YellowSectionSubtitle>
          </Flex>
          <Flex
            flex="1"
            style={{
              alignItems: "end",
              marginRight: "5%",
              justifyContent: "end",
            }}
          >
            <StyledImage src={imageUrl} alt="suggested-plan" />
          </Flex>
        </Flex>
      </YellowSection>
      <ResultContainer>
        <Flex centerV center column>
          <ResultTitle>{recommendation.title}</ResultTitle>
          <ResultSubtitle>{recommendation.phrase1}</ResultSubtitle>
          <ResultPhrase>{recommendation.phrase2}</ResultPhrase>
        </Flex>
        <Flex style={{ padding: "3% 5%" }}>
          <StyledBackButton onClick={() => startOver()}>
            Volver al inicio
          </StyledBackButton>
          <StyledNextButton
            onClick={() => {
              window.top.location.href = `${
                url || "https://confiansa.bi.com.gt/contacto/"
              }`;
            }}
          >
            Conocer más
          </StyledNextButton>
        </Flex>
        <Flex
          style={{
            margin: "1rem",
            justifyContent: "center",
            width: "100%",
            color: "#003865",
          }}
        >
          Revisa tu correo para más información del seguro recomendado.
        </Flex>
      </ResultContainer>
    </RecommendationWrapper>
  );
}
